import { GdprRequestScriptRenderer } from "./gdpr-request-script-renderer";
import { IGdprRequestWidgetData, IGdprRequestWidgetDataShort } from "@pageBuilder/typings";
import { FormWidgetBaseRenderer } from "../../form-widget/form-widget-base-renderer";
import { IWidgetWithFormData } from "@pageBuilder/typings";
import { Base64Util } from "../../../../utils/base64-util";
import { IRenderingCommonContext } from "@commonRendering/types";
import { FormTruCaptchaScriptRenderer } from "../../form-widget/form-trucaptcha-script.renderer";
import { FormReCaptchaScriptRenderer } from "../../form-widget/form-recaptcha-script.renderer";

export class GdprRequestWidgetRenderer extends FormWidgetBaseRenderer {

    private readonly DATA_ATTRIBUTE = "data-gdpr-request";
    private readonly FORM_ACTION = "/_api/gdpr/request";
    private readonly scriptRenderer: GdprRequestScriptRenderer;
    private readonly recaptchaScriptRenderer: FormReCaptchaScriptRenderer;
    private readonly truCaptchaScriptRenderer: FormTruCaptchaScriptRenderer;

    constructor(renderingCommonContext: IRenderingCommonContext) {
        super(renderingCommonContext);
        this.scriptRenderer = new GdprRequestScriptRenderer();
        this.recaptchaScriptRenderer = new FormReCaptchaScriptRenderer();
        this.truCaptchaScriptRenderer = new FormTruCaptchaScriptRenderer();
    }

    protected createNewInternal(): HTMLElement {
        return this.createWidgetElement("gdprRequestWidget");
    }

    protected override createForm(): HTMLFormElement {
        const form = super.createBaseForm();
        form.action = this.FORM_ACTION;
        return form;
    }

    protected override renderFormWidgetInternal(element: HTMLElement, data: IWidgetWithFormData): HTMLElement {
        const renderedElement = super.renderBaseInternal(element, data, true);
        this.setAttributes(element, data as IGdprRequestWidgetData);

        this.cleanupScripts();
        if (this.renderingCommonContext.data.captchaInfo.captchaProtectionType === "TruCaptcha") {
            this.truCaptchaScriptRenderer.renderCommon(this.renderedDocument);
        } else if (this.renderingCommonContext.data.captchaInfo.captchaProtectionType === "ReCaptcha"){
            this.recaptchaScriptRenderer.renderCommon(this.renderedDocument);
        }

        this.scriptRenderer.renderCommon(this.renderedDocument);
        this.scriptRenderer.renderLocal(element);

        this.renderStyles(element, data);

        return renderedElement;
    }

    private setAttributes(element: HTMLElement, data: IGdprRequestWidgetData): void {
        const dataForSave = this.prepareDataForSave(data);
        const json = Base64Util.serialize(dataForSave) || "";

        element.setAttribute(this.DATA_ATTRIBUTE, json);
        element.toggleAttribute("data-primary-element", data.primaryElement);
        if (this.isEditorRendering) {
            element.setAttribute("data-draft", "true");
        }
    }

    private prepareDataForSave(data: IGdprRequestWidgetData): IGdprRequestWidgetDataShort {
        return {
            fields: data.fields,
            submit: data.submit,
            deleteInfoDetailsField: data.deleteInfoDetailsField,
            correctInfoDetailsField: data.correctInfoDetailsField,
            callToDiscussDetailsField: data.callToDiscussDetailsField
        };
    }

    protected override setFormData(form: HTMLFormElement, data: IWidgetWithFormData): void {
        super.setBaseFormData(form, data);
    }

    private cleanupScripts(): void {
        this.truCaptchaScriptRenderer.cleanupCommon(this.renderedDocument);
        this.recaptchaScriptRenderer.cleanupCommon(this.renderedDocument);
    }

}
